import { render, staticRenderFns } from "./FixedFlex.vue?vue&type=template&id=77565d1a&scoped=true"
import script from "./FixedFlex.vue?vue&type=script&lang=js"
export * from "./FixedFlex.vue?vue&type=script&lang=js"
import style0 from "./FixedFlex.vue?vue&type=style&index=0&id=77565d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77565d1a",
  null
  
)

export default component.exports